export default __webpack_public_path__ + "e2a92fbe1e361f3f1eb1ff846cf22f81.png";